import Api from './Api'
import { errorHandler } from '../../utils'
import {
  AddManualSubscriptionInterface,
  BuySubscriptionInterface,
  SubscriptionInterface,
} from 'interfaces/AccountingInterface'
import axios from 'axios'
import { DataTableColumns } from 'interfaces'

class Subscription extends Api {
  readonly urls = {
    hasPharmacySubscribe: '/Subscription/HasPharmacySubscribe',
    getSubscriptionsType: '/SubscriptionType/AllActiveSubscriptionType',
    getBankGateways: 'https://api.daroog.com/payment/GetBankGetwayes',
    buySubscriptions: '/Subscription/Buy',
    getSubscriptions: '/Subscription/GetPharmacySubscribes',
    all: '/SubscriptionType/AllSubscriptionType',
    save: '/SubscriptionType/Save',
    remove: '/SubscriptionType/Remove/',
    getAllSubscribes: '/Subscription/GetAllSubscribes',
    addManual: '/Subscription/AddManual',
  }

  hasPharmacySubscribe = async (): Promise<any> => {
    try {
      const result = await this.postJsonData(this.urls.hasPharmacySubscribe)
      localStorage.setItem('hasSubscribe', result.data.data.hasSubscribe)
      if (result.data.data.expireDay != undefined) {
        localStorage.setItem('SubscriptionExpireDays', result.data.data.expireDay)
      } else {
        localStorage.setItem('SubscriptionExpireDays', '0')
      }
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  getSubcriptionsType = async (): Promise<any> => {
    try {
      const result = await this.postData(this.urls.getSubscriptionsType)
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  getBankGatewayes = async (): Promise<any> => {
    try {
      const result = await axios.post(this.urls.getBankGateways)
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  buySubscriptions = async (data: BuySubscriptionInterface): Promise<any> => {
    try {
      const result = await this.postJsonData(this.urls.buySubscriptions, data)
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  getSubcriptions = async (
    skip: number = 0,
    top: number = 10,
    searchableColumns: DataTableColumns[] = [],
    searchText: string = '',
  ): Promise<any> => {
    try {
      const url =
        this.urls.getSubscriptions +
        `?$top=${top}&$skip=${skip * top}&$orderby=id desc`

      const result = await this.postData(url)
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  save = async (data: SubscriptionInterface): Promise<any> => {
    try {
      const result = await this.postJsonData(this.urls.save, data)
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  addManual = async (data: AddManualSubscriptionInterface): Promise<any> => {
    try {
      const url =
        this.urls.addManual +
        `?pharmacyId=${data.pharmacyId}&subscriptionTypeId=${data.subscriptionTypeId}&amount=${data.amount}
        &title=${data.title}`
      const result = await this.postData(url)
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  all = async (skip: number = 0, top: number = 10): Promise<any> => {
    try {
      const result = await this.postJsonData(
        `${this.urls.all}?$top=${top}&$skip=${skip * top}&$orderby=id desc`,
      )
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  remove = async (id: number | string): Promise<any> => {
    try {
      const result = await this.postJsonData(`${this.urls.remove}${id}`)
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  getAllSubscribes = async (
    skip: number = 0,
    top: number = 10,
  ): Promise<any> => {
    try {
      const result = await this.postJsonData(
        `${this.urls.getAllSubscribes}?$top=${top}&$skip=${skip * top
        }&$orderby=id desc`,
      )
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }
}

export default Subscription
